import React, { Dispatch, useState } from "react"
import { Modal, Button, Input, Spin, message } from "antd"
import { BarcodeOutlined } from "@ant-design/icons"
import { LoadingOutlined } from "@ant-design/icons"
import { updateOLPN } from "../../api/OLPN/olpn"
import { useOlpnContext } from "./OlpnContext"

const OlpnModal = (props: {
  setOLPNModal: Dispatch<boolean>, OLPNModal: boolean, currentOLPN: string | undefined, bpId: string | undefined,
  setValue: Dispatch<string>, value: string, setCloseOLPN: Dispatch<boolean>, progress: any, handleOLPN: any
}) => {
  const [error, setError] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const { setOLPNModal, OLPNModal, currentOLPN, bpId, setValue, value, setCloseOLPN } = props
  const { setOlpn } = useOlpnContext()

  const handleCloseOLPN = async () => {
    if (value.length === 0) return setError(true)
    setError(false)
    if (currentOLPN && bpId) {
      setLoading(true)
      const res = await updateOLPN(currentOLPN, value, bpId)
      if (res.status === 200) {
        setCloseOLPN(false)
        setOlpn(undefined)
        setOLPNModal(false)
        message.success("L'OLPN " + value + " a bien été assigné")
        setValue("")
      }
      setLoading(false)
    }
  }

  return (
    <Modal
      open={OLPNModal}
      footer={[
        <Button key="cancel" onClick={() => { setOLPNModal(false); setValue("") }}>Annuler</Button>,
        <Button key="ok" disabled={loading} className={!loading ? "validate-button" : 'loading-button'} onClick={() => handleCloseOLPN()}>
          <Spin indicator={<LoadingOutlined className='loading-icon' />} spinning={loading}>
            Valider
          </Spin>
        </Button>
      ]}
      title={"Saisissez l'OLPN"}
      onCancel={() => { setOLPNModal(false); setValue("") }}
    >
      <h4>Veuillez saisir l'oLPN</h4>
      <Input allowClear value={value} status={error ? 'error' : ''} prefix={<BarcodeOutlined />} onChange={(e) => setValue(e.target.value)} placeholder="OLPN" />
    </Modal>
  )
}

export default OlpnModal